import produce from 'immer';

// @ts-ignore
import { LeaderboardState } from '../types';
// eslint-disable-next-line no-unused-vars
import { Action } from '../../../../types';
import {
    SET_NAV_ITEM,
    SET_LEADERBOARD_DATA,
    SET_LEADERBOARD_FILTER
} from '../actions';
import { setNavItem } from '../../shared/reducer';
import {} from './';
import { setLeaderboardData } from './set-leaderboard-data';
import { setLeaderboardFilter } from './set-leaderboard-filter';

/**
 * @type {LeaderboardState}
 */
const initialState = {
    nav: {
        round: -1,
        club: -1
    },
    requests: [],
    data: {},
    filter: ''
};

/**
 * @param {LeaderboardState} state - The Redux state.
 * @param {Action} action - The Redux action.
 * @returns {LeaderboardState} The updated Redux state.
 */
export const leaderboardReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_LEADERBOARD_DATA:
                setLeaderboardData(draft, action.payload);
                break;
            case SET_NAV_ITEM:
                setNavItem(draft, action.payload);
                break;
            case SET_LEADERBOARD_FILTER:
                setLeaderboardFilter(draft, action.payload);
                break;
            default:
                draft;
        }
    });
};
